/**
 * Created by Karol Kluska on 12.06.17.
 */

angular
  .module('app')
  .component('rateplanAvailability', {
    controller: RateplanAvailability,
    bindings: {
      currencyPrefix: '<',
      currencySuffix: '<',
      from: '<',
      monthsLength: '<',
      calendarsInRow: '<',
      groupId: '<',
      rateplanId: '<',
      personsCount: '<',
      onStartLoading: '&',
      onEndLoading: '&',
      queryIndex: '<'
    },
    templateUrl: 'app/shared/rateplanAvailability/RateplanAvailability.html'
  });

/** @ngInject */
function RateplanAvailability($rootScope, Restangular, Params) {
  var $this = this;
  $this.$rootScope = $rootScope;
  $this.Restangular = Restangular;
  $this.userHash = Params.getUserHash();
  $this.hotelId = Params.getHotelId();
}

RateplanAvailability.prototype = {
  $onChanges: function () {
    this.to = moment(this.from).add(this.monthsLength - 1, 'months').endOf('month');
    this.getCalendarData(this.from, this.to);
  },

  getMonths: function () {
    var monthsLength = Math.abs(moment(this.from).diff(this.to, 'months')) + 1;
    var result = [];

    for (var i = 0; i < monthsLength; i++) {
      result.push(moment(this.from).add(i, 'months').format('YYYY-MM-DD'));
    }

    return result;
  },

  changePeriod: function (from, to) {
    if (moment(from).isSameOrAfter(moment(), 'month')) {
      this.getCalendarData(from, to);
    }
  },

  isFullyRestricted: function () {
    return this.rateplanId > 0;
  },

  getCalendarData: function (from, to) {
    var $this = this;
    $this.onStartLoading();
    /* eslint-disable camelcase */
    var requestParams = {
      start: moment(from).startOf('month').subtract(1, 'day').format('YYYY-MM-DD'),
      end: moment(to).endOf('month').add(1, 'day').format('YYYY-MM-DD'),
      group_id: $this.groupId,
      rateplan_id: $this.rateplanId,
      persons_count: $this.personsCount,
      hotel_id: $this.hotelId
    };
    /* eslint-enable camelcase */
    $this.Restangular.all('bookingengine/api/be/calendar').post(requestParams)
      .then(function (offers) {
        $this.from = moment(from).startOf('month');
        $this.to = moment(to).endOf('month');
        $this.offers = offers;
        $this.onEndLoading();
      })
      .catch(function () {
        $this.$state.go('booking.clientErrors', {}, {location: false});
      })
      .finally(function () {
        $this.onEndLoading();
      });
  }
};
